// extracted by mini-css-extract-plugin
export var Footer = "W_dx";
export var aniBgLoading = "W_f";
export var aniSpin = "W_d";
export var column = "W_bk";
export var columns = "W_dB";
export var heading = "W_D";
export var link = "W_bl";
export var main = "W_c";
export var nav = "W_bj";
export var newsletter = "W_dC";
export var newsletter__heading = "W_dD";
export var scrollTop = "W_dy";
export var scrollTop__btn = "W_dz";